function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $64f0bb643458bdba$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"g3LtT":"index.f4071d44.js","3OvMG":"star-01.963fdfec.png","jYl4j":"demo.5f669aad.png","1gW7p":"github.80cd6239.png"}'));

var $95890654fdb86048$exports = {};

$95890654fdb86048$exports = new URL((parcelRequire("27Lyk")).resolve("3OvMG"), import.meta.url).toString();


var $de6e7b66aa3e75a7$exports = {};

$de6e7b66aa3e75a7$exports = new URL((parcelRequire("27Lyk")).resolve("jYl4j"), import.meta.url).toString();


var $6f03581bb901ec7a$exports = {};

$6f03581bb901ec7a$exports = new URL((parcelRequire("27Lyk")).resolve("1gW7p"), import.meta.url).toString();


const $54b47fc030b7b21e$var$username = "pawel-haraf";
const $54b47fc030b7b21e$var$direction = "desc";
const $54b47fc030b7b21e$var$repositoriesContainer = document.querySelector(".repositories--js");
const $54b47fc030b7b21e$var$tags = document.querySelector(".tags--js");
fetch(`https://api.github.com/users/${$54b47fc030b7b21e$var$username}/repos?direction=${$54b47fc030b7b21e$var$direction}`).then((response)=>response.json()).then((response)=>{
    for (let repository of response){
        const { name: name, stargazers_count: stargazers_count, description: description, homepage: homepage, html_url: html_url, topics: topics } = repository;
        let tags = ``;
        for (let tag of topics)tags += `<p class="bg-gray-400/10 px-2 py-1 text-white font-bold text-sm rounded ">${tag}</p>`;
        const element = `
            <div class="bg-gray-800 rounded-2xl max-w-[648px]">
                    <div class="bg-white/[.15] flex items-center gap-2 p-4 shadow-inner group rounded-t-2xl border-b
                        border-b-bgBody">
                        <span class="rounded-md bg-bgBody w-3 h-3 group-hover:bg-red-500"> </span>
                        <span class="rounded-md bg-bgBody w-3 h-3"> </span>
                        <span class="rounded-md bg-bgBody w-3 h-3 group-hover:bg-green-500"> </span>
                    </div>
                    <div class="m-5 md:m-10">
                        <div class="flex gap-4 items-center mb-4">
                            <h3 class="text-2xl font-bold">${name}</h3>
                            <div class="flex gap-0.5 items-center px-2 py-1 bg-gray-400/10 text-gray-400">
                                <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($95890654fdb86048$exports)))}" alt="">
                                <p class="text-base">${stargazers_count}</p>
                            </div>
                        </div>

                        <p class="text-xl">
                        ${description}
                        </p>
                        <div class="tags--js flex gap-2 mt-4 mb-10">
                            ${tags}
                        </div>
                        <div class="flex flex-col md:flex-row gap-4 text-base whitespace-nowrap">
                            <a href="${homepage}"
                                class="btn-js w-40 md:w-44" target="_blank" rel="noopener noreferrer">
                                <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($de6e7b66aa3e75a7$exports)))}" alt="">
                                <p>View demo</p>
                            </a>
                            <a href="${html_url}"
                                class="btn-js w-44 md:w-48" target="_blank" rel="noopener noreferrer">
                                <img src="${(0, (/*@__PURE__*/$parcel$interopDefault($6f03581bb901ec7a$exports)))}" alt="" >
                                <p>Source code</p>
                            </a>
                        </div>
                    </div>
                </div>
            `;
        if (description) $54b47fc030b7b21e$var$repositoriesContainer.insertAdjacentHTML("beforeend", element);
    }
}).catch((e)=>console.log(e));


//# sourceMappingURL=index.f4071d44.js.map
